import { deleteClaimContext } from './deleteClaimContext';

export const deleteClaimContexts = async ({ claims }) => {
  return Promise.all([
    claims.map((claim) => deleteClaimContext({ claimId: claim.claimId })),
  ]);
};
